import { call, put, takeEvery } from 'redux-saga/effects';
import { USER_FORGOT_PASSWORD_REQUEST } from '../constants/password.constants';
import { forgotPasswordRequestSuccess, forgotPasswordRequestFailure } from '../actions/account_actions/forgot_password.actions';
import { sendForgotPasswordRequest } from '../../requests/account_requests';
import { message_success, message_error } from '../../../../components/Message';

function* forgotPasswordRequest({ email }) {
    const forgotPasswordParams = yield call(sendForgotPasswordRequest, email);
    const { result, error } = forgotPasswordParams;
    if (result) {
        yield put(forgotPasswordRequestSuccess());
        message_success('You should receive an email in the next few minutes. Please the link inside this link and reset your password.', 2000);
    } else {
        yield put(forgotPasswordRequestFailure(error));
        message_error(error);
    }
}

export default function* forgotPasswordSaga() {
    yield takeEvery(USER_FORGOT_PASSWORD_REQUEST, forgotPasswordRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/forgot_password.saga.js